module.exports = __webpack_public_path__ + "static/media/codeClock.142dde52.png";